import { ArrowRight, ArrowUpRight, Check } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

const MagicSection = () => {
  const { t } = useLanguage();
  return (
    <section className="border-t border-white/10 px-6 py-28 md:px-12 md:py-40" data-testid="magic-section">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 md:grid-cols-12">
        <Reveal className="md:col-span-5">
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-neon">{t.magic.kicker}</p>
          <div className="flex items-center gap-5">
            <img
              src="/assets/parole-in-treno.webp"
              alt="Parole in Treno"
              className="h-24 w-auto max-w-52 border border-white/15 bg-surface object-contain p-2"
              data-testid="magic-image"
            />
            <div>
              <span className="font-mono text-[10px] uppercase tracking-widest text-muted2">{t.magic.badge}</span>
              <h2 className="font-display text-4xl font-extrabold uppercase tracking-tight sm:text-5xl" data-testid="magic-title">
                {t.magic.title}
              </h2>
            </div>
          </div>
          <p className="mt-8 max-w-md text-sm leading-relaxed text-muted2 md:text-base">{t.magic.desc}</p>
          <ul className="mt-6 space-y-2.5 text-sm text-muted2">
            {t.magic.includes.map((i) => (
              <li key={i} className="flex gap-2">
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-neon" />
                {i}
              </li>
            ))}
          </ul>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              href="https://www.hydeofficialstore.com/prodotto.php?id=31"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="magic-store-link"
              className="group inline-flex items-center gap-2 rounded-full border border-white/20 px-7 py-3.5 font-mono text-xs uppercase tracking-widest transition-colors duration-300 hover:border-neon hover:text-neon"
            >
              {t.magic.cta}
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <Link
              to="/apps/lampo-magic"
              data-testid="magic-lampo-link"
              className="group inline-flex items-center gap-2 rounded-full border border-[#E11D48]/40 px-7 py-3.5 font-mono text-xs uppercase tracking-widest text-[#E11D48] transition-colors duration-300 hover:border-[#E11D48] hover:bg-[#E11D48]/10"
            >
              {t.magic.lampoLink}
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
            </Link>
          </div>
        </Reveal>
        <Reveal delay={0.15} className="md:col-span-7">
          <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.3em] text-muted2">{t.magic.video}</p>
          <div className="relative aspect-video w-full overflow-hidden border border-white/15 bg-surface" data-testid="magic-video">
            <iframe
              src="https://www.youtube-nocookie.com/embed/RMV_liFbNSw"
              title="Parole in Treno — video di lancio"
              className="absolute inset-0 h-full w-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              loading="lazy"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default MagicSection;
